import Presenter from './Presenter';

const BusinessCTAContainer = () => {
    return <Presenter />;
};

export default BusinessCTAContainer;
